<template>
<div>
	<!-- Barre de menu -->
	<b-navbar toggleable="lg" type="dark" style="background-color:#24AAE1 !important;" variant="dark">
		<b-navbar-brand :to="'/indexClient'" style="padding-top: 5px;width: 6vw;"><img src="https://aloha.crm-ideal.fr/img/LOGO IDEAL SOLUTIONS-blanc_horizontal.png" alt="Ideal Solution" style="width: 100%;"/></b-navbar-brand>
		<!-- <b-collapse is-nav id="nav_collapse"> -->
		<b-navbar-nav is-nav style="align-content: center;align-items: center; width: 75vw;">
			<el-button-group style="flex: 0 0 78%;">
				<div id="triple_button">
					<div class="button_icons">
						<el-button icon="fas fa-home" v-on:click="redirectAccueil" plain></el-button>
						<p>Accueil</p>
					</div>
					<div class="button_icons">
						<el-button icon="fas fa-archive" v-on:click="redirectDocuments" plain></el-button>
						<p>Mes Documents</p>
					</div>
					<div class="button_icons">
						<el-button icon="fas fa-dollar-sign" v-on:click="redirectEcommerce" plain></el-button>
						<p>E-Commerce</p>
					</div>
					<div class="button_icons">
						<el-button icon="fas fa-ticket-alt" v-on:click="redirectAssistance" plain></el-button>
						<p>Mes tickets</p>
					</div>
					<!-- <div class="button_icons">
						<el-button icon="fas fa-info-circle" v-on:click="redirectAide" plain></el-button>
						<p>Aide</p>
					</div> -->
				</div>
			</el-button-group>
			<b-nav-item style="white-space:nowrap;">{{ time }}</b-nav-item>
			<b-nav-item-dropdown right>
				<template slot="button-content"><span class="far fa-building"></span> {{ info.socname }}</template>
				<b-dropdown-item v-for="(res, index) in info.multisite" :key="index" :value="res.socid" @click="changeTiers(res,info.socname)">{{res.socname}}</b-dropdown-item>
			</b-nav-item-dropdown>
			<b-nav-item-dropdown right>
				<template slot="button-content"><span class="fas fa-user"></span> {{ info.prenom+" "+info.nom }}</template>
				<b-dropdown-item :to="'/profilClient'"><span class="far fa-address-card"></span> Mon profil</b-dropdown-item>
				<b-dropdown-item v-on:click="disconnect()"><span class="fas fa-power-off"></span> Déconnexion</b-dropdown-item>
			</b-nav-item-dropdown>
		</b-navbar-nav>
	</b-navbar>
		<!--<b-navbar-toggle target="verticalMenu"><img src="/img/LOGO IDEAL SOLUTIONS-blanc_carre_25px.png" alt="Ideal Solution" data-toggle='tooltipIdeal' title='Cliquez-ici pour ouvrir le menu de navigation' @click="toggleNav()"/></b-navbar-toggle>-->
</div>
</template>

<script>
import script from '../../../script/script.js';
var moment = require('moment');
export default {
  data() {
    return {
			post: {},
			time: moment().format('LLLL'),
			intervalTime:null
    }
	},
	beforeCreate:function(){
		moment.locale('fr')
	moment.tz.setDefault("Europe/Paris");
	},
  mounted:function(){
		this.loadingInfo();
		this.intervalTime = setInterval(() => this.time = moment().format('LLLL'), 500);
  },
	beforeDestroy:function(){
		clearInterval(this.intervalTime);
	},
  methods: {
		changeTiers: script.changeTiers,
    	disconnect: script.disconnect,
		loadingInfo: script.loadingInfo,
		redirectAccueil(){
			this.$router.push({ path: '/indexClient' })
		},
		redirectDocuments(){
			this.$router.push({ path: '/mesDocuments' })
		},
		redirectEcommerce(){
			this.$router.push({ path: '/e-commerce' })
		},
		redirectAssistance(){
			this.$router.push({ path: '/assistance' })
		},
		redirectAide(){
			this.$router.push({ path: '/aideClient' })
		},

	},
	created:function(){

	},
	computed:{
		info(){
			return this.$store.state.info
		}
	}
}
</script>

<style scoped>
#triple_button{
    padding-left: 1vw;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  #triple_button > .button_icons{
    text-align: center;
	padding: 0 0.5em;
  }

  #triple_button button{
    background-color: transparent;
    color: white;
    border: none;
    font-size: 1.2vw;
    transition: all .5s ease;
	box-shadow: none;
	margin: 0;
  }

  #triple_button p{
    font-size: 70%;
    color: white;
    margin-top: -20%;
    margin-left: 0;
    margin-bottom: 0;
    text-align: center;
    cursor: default;
  }

  #triple_button button:hover {
    background-color: transparent;
  }
</style>
